import * as React from 'react'

import { ClosingReqContextProvider } from './context'
import type { RequirementsToCloseProps } from './typings'
import { RequirementsToClose } from './RequirementsToClose'

export function RequirementsToCloseWrapper(props: RequirementsToCloseProps) {
  return (
    <ClosingReqContextProvider>
      <RequirementsToClose {...props} />
    </ClosingReqContextProvider>
  )
}
